import { useCssVars as _useCssVars, defineComponent as _defineComponent } from 'vue'
import { createVNode as _createVNode, resolveComponent as _resolveComponent, withCtx as _withCtx, unref as _unref, renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createTextVNode as _createTextVNode } from "vue"

const _hoisted_1 = { key: 0 }
const _hoisted_2 = {
  key: 2,
  class: "text-center"
}

import {reactive, computed, shallowRef, watch} from 'vue';
import {ordersService} from '@/api/services/order';
import {useSettingsStore} from '@/api/store/settings';
import {filterValues, sortValues} from "@/views/OrdersComponents/Helpers";
import ButtonFilterSelect from "@/components/custom/ButtonFilterSelect/ButtonFilterSelect.vue";
import SearchFilter from "@/components/custom/SearchFilter.vue";
import debounce from 'lodash/debounce';
import OrderCard from "@/views/OrdersComponents/OrderDetails/OrderCard.vue";


export default /*@__PURE__*/_defineComponent({
  __name: 'OrdersView',
  setup(__props) {

_useCssVars(_ctx => ({
  "v2d3b185f": (_unref(setAppColor))
}))

const settingsStore = useSettingsStore();

const setAppColor = settingsStore.settings.buttonColor2

// Data
const state = reactive({
  items: [] as any[],
  pagination: {
    meta: {},
    links: [],
    next_page_url: null,
  },
  search: '' as string,
  filterSelected: 'filter' as string,
});

const sortTabSelectedValue = shallowRef({
  name: 'Sort',
  label: 'Sort'
})
const filterTabSelectedValue = shallowRef({
  name: 'Filter',
  label: 'Filter'
})
const page = shallowRef(1)

// Computed
const isFilterTabSelected = computed(() => {
  return state.filterSelected === 'filter'
});

const isSortTabSelected = computed(() => {
  return state.filterSelected === 'sort'
});

const filterQueryString = computed(() => {
  let filter = {
    sorting: '',
    search: state.search,
    page: page.value,
    payment_status: '',
  };

  let sortOrder = sortTabSelectedValue.value.name === 'Sort' ? 'desc' : sortTabSelectedValue.value.name;

  let filterValue = filterTabSelectedValue.value.name === 'Filter' ? 'title' : filterTabSelectedValue.value.name;

  if (filterTabSelectedValue.value.name === 'Filter' && sortTabSelectedValue.value.name === 'Sort') {
    filter.sorting = 'id,desc';
  } else {
    if (filterValue === 'paid' || filterValue === 'not_paid') {
      filter.payment_status = filterValue;
      filter.sorting = `id,${sortOrder}`;
    } else {
      filter.sorting = `${filterValue},${sortOrder}`;
    }
  }

  return filter;
});

const getOrders = () => {
  ordersService.index(filterQueryString.value).then((response) => {
    state.items.push(...response.data)
    state.pagination.meta = response.meta;
    state.pagination.links = response.links;
    state.pagination.next_page_url = response.next_page_url;
  });
}

// Debounced to fetch getMedicalAlerts
const debouncedGetOrders = debounce(getOrders, 300);

const resetState = () => {
  page.value = 1;
  state.items = [];
}

const seeMore = () => {
  if (state.pagination.next_page_url) {
    page.value++;
    getOrders();
  }
}

watch(() => [filterTabSelectedValue.value, sortTabSelectedValue.value, state.search], () => {
  resetState();
  debouncedGetOrders();
});

getOrders();

return (_ctx: any,_cache: any) => {
  const _component_v_col = _resolveComponent("v-col")!
  const _component_v_row = _resolveComponent("v-row")!
  const _component_v_alert = _resolveComponent("v-alert")!
  const _component_v_card = _resolveComponent("v-card")!
  const _component_v_btn = _resolveComponent("v-btn")!
  const _component_v_container = _resolveComponent("v-container")!

  return (_openBlock(), _createBlock(_component_v_container, {
    class: "px-0 pt-0 pb-12 position-relative",
    style: {"background-color":"#F0F0F0","min-height":"100vh"}
  }, {
    default: _withCtx(() => [
      _createVNode(_component_v_row, {
        class: "mt-0 mb-2 py-5 text-center",
        "no-gutters": "",
        style: {"background-color":"#FFF"}
      }, {
        default: _withCtx(() => [
          _createVNode(_component_v_col, { cols: "12" }, {
            default: _withCtx(() => [
              _createVNode(SearchFilter, {
                "onUpdate:modelValue": _cache[0] || (_cache[0] = (val) => state.search = val)
              })
            ]),
            _: 1
          }),
          _createVNode(_component_v_col, {
            class: "d-flex px-3",
            cols: "12"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[2] || (_cache[2] = ()=>state.filterSelected = 'sort')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: sortTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((sortTabSelectedValue).value = $event)),
                    "is-tab-selected": isSortTabSelected.value,
                    items: _unref(sortValues),
                    multiple: false,
                    text: sortTabSelectedValue.value,
                    icon: "sort-icon",
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "items", "text"])
                ]),
                _: 1
              }),
              _createVNode(_component_v_col, {
                class: "mt-1 position-relative left-filter-text",
                onClick: _cache[4] || (_cache[4] = ()=> state.filterSelected = 'filter')
              }, {
                default: _withCtx(() => [
                  _createVNode(ButtonFilterSelect, {
                    modelValue: filterTabSelectedValue.value,
                    "onUpdate:modelValue": _cache[3] || (_cache[3] = ($event: any) => ((filterTabSelectedValue).value = $event)),
                    "is-tab-selected": isFilterTabSelected.value,
                    items: _unref(filterValues),
                    multiple: false,
                    text: filterTabSelectedValue.value,
                    "single-line": ""
                  }, null, 8, ["modelValue", "is-tab-selected", "items", "text"])
                ]),
                _: 1
              })
            ]),
            _: 1
          })
        ]),
        _: 1
      }),
      (!_unref(settingsStore).loading)
        ? (_openBlock(), _createElementBlock("section", _hoisted_1, [
            (_openBlock(true), _createElementBlock(_Fragment, null, _renderList(state.items, (order) => {
              return (_openBlock(), _createBlock(OrderCard, {
                key: order.id,
                "button-color": _unref(settingsStore).settings.buttonColor,
                order: order,
                "orders-background-color": _unref(setAppColor)
              }, null, 8, ["button-color", "order", "orders-background-color"]))
            }), 128))
          ]))
        : _createCommentVNode("", true),
      (state.items.length == 0)
        ? (_openBlock(), _createBlock(_component_v_card, {
            key: 1,
            class: "mt-4 mx-4 mb-3",
            height: "50vh"
          }, {
            default: _withCtx(() => [
              _createVNode(_component_v_row, {
                class: "my-2 py-1",
                "no-gutters": ""
              }, {
                default: _withCtx(() => [
                  _createVNode(_component_v_col, {
                    class: "my-1 px-10 text-center",
                    cols: "12"
                  }, {
                    default: _withCtx(() => [
                      (!_unref(settingsStore).loading)
                        ? (_openBlock(), _createBlock(_component_v_alert, {
                            key: 0,
                            type: "info",
                            variant: "tonal"
                          }, {
                            default: _withCtx(() => [...(_cache[5] || (_cache[5] = [
                              _createTextVNode("No Orders Found", -1)
                            ]))]),
                            _: 1
                          }))
                        : _createCommentVNode("", true)
                    ]),
                    _: 1
                  })
                ]),
                _: 1
              })
            ]),
            _: 1
          }))
        : _createCommentVNode("", true),
      (state.pagination.next_page_url)
        ? (_openBlock(), _createElementBlock("div", _hoisted_2, [
            _createVNode(_component_v_btn, {
              ripple: false,
              class: "load-more text-capitalize font-size-12-600",
              variant: "plain",
              onClick: seeMore
            }, {
              default: _withCtx(() => [...(_cache[6] || (_cache[6] = [
                _createTextVNode(" Load More ", -1)
              ]))]),
              _: 1
            })
          ]))
        : _createCommentVNode("", true)
    ]),
    _: 1
  }))
}
}

})